{
  "name": "rawi",
  "description": "Rawi (راوي) is the developer-friendly AI CLI that brings the power of 11 major AI providers directly to your terminal. With seamless shell integration, persistent conversations, and 200+ specialized prompt templates, Rawi transforms your command line into an intelligent development workspace.",
  "version": "0.0.11",
  "type": "module",
  "license": "MIT",
  "bin": {
    "rawi": "dist/index.js"
  },
  "man": [
    "./man/rawi.1"
  ],
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "files": [
    "/dist",
    "/man/rawi.1",
    "/index.d.ts"
  ],
  "keywords": [
    "ai",
    "cli",
    "artificial-intelligence",
    "terminal",
    "command-line",
    "developer-tools",
    "shell-integration",
    "openai",
    "anthropic",
    "google",
    "azure",
    "bedrock",
    "ollama",
    "lmstudio",
    "mistral",
    "xai",
    "qwen",
    "chatgpt",
    "claude",
    "gemini",
    "deepseek",
    "conversation",
    "prompt-templates",
    "development",
    "productivity",
    "automation",
    "assistant",
    "copilot",
    "nodejs",
    "typescript",
    "multi-provider",
    "workspace"
  ],
  "author": {
    "name": "Mohammad Abu Mattar",
    "email": "mohammad.khaled@outlook.com",
    "url": "https://mkabumattar.github.io"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/withrawi/rawi.git"
  },
  "bugs": {
    "url": "https://github.com/withrawi/rawi/issues"
  },
  "homepage": "https://rawi.mkabumattar.com",
  "scripts": {
    "scripts:ollama": "tsx scripts/ollama-models-list.ts && pnpm fmt:fix",
    "build": "rimraf dist && NODE_OPTIONS=--max-old-space-size=8192 tsup --tsconfig tsconfig.json",
    "dev": "tsx src/index.ts",
    "start": "node dist/index.js",
    "test": "vitest",
    "test:coverage": "vitest --coverage",
    "lint": "biome check .",
    "lint:fix": "biome check --fix .",
    "fmt": "biome format .",
    "fmt:fix": "biome format --write .",
    "man:build": "marked-man ./man/rawi.1.md > ./man/rawi.1",
    "man": "man ./man/rawi.1",
    "typecheck": "tsc --noEmit",
    "prebuild": "pnpm scripts:ollama",
    "postbuild": "pnpm man:build && pnpm typecheck"
  },
  "dependencies": {
    "@ai-sdk/amazon-bedrock": "3.0.10",
    "@ai-sdk/anthropic": "2.0.6",
    "@ai-sdk/azure": "2.0.19",
    "@ai-sdk/cerebras": "1.0.11",
    "@ai-sdk/deepseek": "1.0.11",
    "@ai-sdk/google": "2.0.8",
    "@ai-sdk/lmstudio": "npm:@ai-sdk/openai-compatible@1.0.11",
    "@ai-sdk/mistral": "2.0.9",
    "@ai-sdk/openai": "2.0.19",
    "@ai-sdk/provider": "2.0.0",
    "@ai-sdk/provider-utils": "3.0.5",
    "@ai-sdk/xai": "2.0.11",
    "@aws-sdk/credential-providers": "3.873.0",
    "@inquirer/prompts": "7.8.3",
    "@libsql/client": "0.15.12",
    "@oclif/core": "4.5.2",
    "ai": "5.0.22",
    "boxen": "8.0.1",
    "chalk": "5.6.0",
    "cli-table3": "0.6.5",
    "commander": "14.0.0",
    "drizzle-orm": "0.44.4",
    "file-type": "21.0.0",
    "glob": "11.0.3",
    "leven": "4.0.0",
    "officeparser": "5.2.0",
    "ora": "8.2.0",
    "partial-json": "0.1.7",
    "update-notifier": "7.3.1",
    "uuid": "11.1.0",
    "zod": "4.1.0"
  },
  "devDependencies": {
    "@biomejs/biome": "2.2.0",
    "@types/node": "24.3.0",
    "@types/update-notifier": "6.0.8",
    "@vitest/coverage-v8": "3.2.4",
    "marked-man": "2.1.0",
    "rimraf": "6.0.1",
    "tsup": "8.5.0",
    "tsx": "4.20.4",
    "typescript": "5.9.2",
    "vite-tsconfig-paths": "5.1.4",
    "vitest": "3.2.4"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "packageManager": "pnpm@10.15.0"
}
